import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  statusDuration: {
    marginBottom: 10,
    '& div:first-child': {
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: 5,
    },

    '& > hr': {
      opacity: 0.05,
    },
  },
}))

export default useStyles
